<template>
  <div>
    <v-card
        height="350"
        class="rounded-lg white" flat
    >
      <v-card-title class=" mr-3  secondary--text" style="font-size: medium; margin-top: -10px">
        <v-img class="ml-2" src="/img/icons/cheque.svg" max-width="25"></v-img>
        لیست چـک ها
        <v-spacer></v-spacer>
        <v-tooltip right v-if="summary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab icon class="mr-3" href="/report/lastChequesList" target="_blank">
              <v-img class="" src="/img/icons/info_circle.svg" max-width="23"></v-img>
            </v-btn>
          </template>
          مشاهده کامل
        </v-tooltip>
        <v-tooltip right color="secondary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab icon class="" href="/panel/cheque/form/c/false">
              <v-img class="" src="/img/icons/plus_doc.svg" max-width="26"></v-img>
            </v-btn>
          </template>
          ثبت چک جدید
        </v-tooltip>

      </v-card-title>
      <v-tabs style="margin-top: -10px" class="rounded-lg white--text"
              background-color="lightSecondary" color="primary">
        <v-tab class="white--text mr-5" active-class="mr-5 secondary" @click="getReceivedCheques()">
          <span>دریافتنی</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="getPaidCheques()">
          <span>پرداختنی</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="getBackFromReceivedCheques()">
          <span>برگشتی دریافتنی</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="getBackFromPaidCheques()">
          <span class>برگشتی پرداختنی</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="getInFlowCheques()">
          <span class>در جریان وصول</span>
        </v-tab>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  ردیف
                </th>
                <th class="text-center">
                  دریافت از
                </th>
                <th class="text-center">
                  تاریخ سررسید
                </th>
                <th class="text-center">
                  شماره چک
                </th>
                <th class="text-center">
                  مبلغ
                </th>
                <th class="text-center">
                  وضعیت
                </th>
                <th class="text-center">
                  بانک
                </th>
                <th class="text-center">
                  شرح
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(cheque, index) in receivedCheques"
                  @click="$router.push(to(cheque))"  class="cursor-pointer">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ cheque.title }}</td>
                <td class="text-center">{{ cheque.due }}</td>
                <td class="text-center">{{ cheque.serial }}</td>
                <td class="text-center">{{ cheque.value | toMoney(0) }}</td>
                <td class="text-center primary--text">پاس نشده</td>
                <td class="text-center">{{ cheque.bankName }}</td>
                <td class="text-center">{{ cheque.explanation }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  ردیف
                </th>
                <th class="text-center">
                  پرداخت به
                </th>
                <th class="text-center">
                  تاریخ سررسید
                </th>
                <th class="text-center">
                  سریال چک
                </th>
                <th class="text-center">
                  شماره سری
                </th>
                <th class="text-center">
                  مبلغ
                </th>
                <th class="text-center">
                  وضعیت
                </th>
                <th class="text-center">
                  بانک
                </th>
                <th class="text-center">
                  شرح
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(cheque, index) in paidCheques"
                  @click="$router.push(to(cheque))" class="cursor-pointer">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ cheque.title }}</td>
                <td class="text-center">{{ cheque.due }}</td>
                <td class="text-center">{{ cheque.serial }}</td>
                <td class="text-center">{{ cheque.chequebook.serial }}</td>
                <td class="text-center">{{ cheque.value | toMoney(0) }}</td>
                <td class="text-center primary--text">پاس نشده</td>
                <td class="text-center">{{ cheque.bankName || '-' }}</td>
                <td class="text-center">{{ cheque.explanation || '-' }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  ردیف
                </th>
                <th class="text-center">
                  دریافت از
                </th>
                <th class="text-center">
                  تاریخ سررسید
                </th>
                <th class="text-center">
                  شماره چک
                </th>
                <th class="text-center">
                  مبلغ
                </th>
                <th class="text-center">
                  بانک
                </th>
                <th class="text-center">
                  شرح
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(cheque, index) in backFromReceivedCheques"
                  @click="$router.push(to(cheque))" class="cursor-pointer">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ cheque.title }}</td>
                <td class="text-center">{{ cheque.due }}</td>
                <td class="text-center">{{ cheque.serial }}</td>
                <td class="text-center">{{ cheque.value | toMoney(0) }}</td>
                <td class="text-center">{{ cheque.bankName }}</td>
                <td class="text-center">{{ cheque.explanation }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  ردیف
                </th>
                <th class="text-center">
                  پرداخت به
                </th>
                <th class="text-center">
                  تاریخ سررسید
                </th>
                <th class="text-center">
                  سریال چک
                </th>
                <th class="text-center">
                  شماره سری
                </th>
                <th class="text-center">
                  مبلغ
                </th>
                <th class="text-center">
                  بانک
                </th>
                <th class="text-center">
                  شرح
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(cheque, index) in backFromPaidCheques"
                  @click="$router.push(to(cheque))" class="cursor-pointer">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ cheque.title }}</td>
                <td class="text-center">{{ cheque.due }}</td>
                <td class="text-center">{{ cheque.serial }}</td>
                <td class="text-center">{{ cheque.chequebook.serial }}</td>
                <td class="text-center">{{ cheque.value | toMoney(0) }}</td>
                <td class="text-center">{{ cheque.bankName }}</td>
                <td class="text-center">{{ cheque.explanation }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  ردیف
                </th>
                <th class="text-center">
                  در وجه
                </th>
                <th class="text-center">
                  تاریخ سررسید
                </th>
                <th class="text-center">
                  شماره چک
                </th>
                <th class="text-center">
                  مبلغ
                </th>
                <th class="text-center">
                  بانک
                </th>
                <th class="text-center">
                  شرح
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(cheque, index) in inFlowCheques"
                  @click="$router.push(to(cheque))" class="cursor-pointer">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ cheque.title }}</td>
                <td class="text-center">{{ cheque.due }}</td>
                <td class="text-center">{{ cheque.serial }}</td>
                <td class="text-center">{{ cheque.value | toMoney(0) }}</td>
                <td class="text-center">{{ cheque.bankName }}</td>
                <td class="text-center">{{ cheque.explanation }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
      </v-tabs>

    </v-card>

  </div>

</template>

<script>
export default {
  name: "ChequeTable",
  components: {},
  props: {
    id: {},
    summary: {
      default: false
    },

  },
  data() {
    return {
      cheque_type: 0,
      receivedCheques: null,
      paidCheques: null,
      backFromReceivedCheques: null,
      backFromPaidCheques: null,
      inFlowCheques: null,
    };
  },
  mounted() {
    this.getReceivedCheques()
  },
  methods: {
    getReceivedCheques(){
      if(this.receivedCheques == null){
        this.request({
          url: this.endpoint(
              `reports/lists/cheques?limit=${this.list_limit}&offset=0&search=&is_paid=false&type=c&status=notPassed&ordering=-created_at`),
          method: "get",
          success: data => {
            this.receivedCheques = data.results.splice(0,5)
          },
        })
      }
    },
    getPaidCheques(){
      if(this.paidCheques == null){
        this.request({
          url: this.endpoint(
              `reports/lists/cheques?limit=${this.list_limit}&offset=0&search=&is_paid=true&type=c&status=notPassed&ordering=-created_at`),
          method: "get",
          success: data => {
            this.paidCheques = data.results.splice(0,5)
          },
        })
      }
    },
    getBackFromReceivedCheques(){
      if(this.backFromReceivedCheques == null){
        this.request({
          url: this.endpoint(
              `reports/lists/cheques?limit=${this.list_limit}&offset=0&search=&is_paid=false&type=c&status=bounced&ordering=due`
          ),
          method: "get",
          success: data => {
            this.backFromReceivedCheques = data.results.splice(0,5)
          },
        })
      }
    },
    getBackFromPaidCheques(){
      if(this.backFromPaidCheques == null){
        this.request({
          url: this.endpoint(
              `reports/lists/cheques?limit=${this.list_limit}&offset=0&search=&is_paid=true&type=c&status=bounced&ordering=due`
          ),
          method: "get",
          success: data => {
            this.backFromPaidCheques = data.results.splice(0,5)
          },
        })
      }
    },
    getInFlowCheques(){
      if(this.inFlowCheques == null){
        this.request({
          url: this.endpoint(
              `reports/lists/cheques?limit=${this.list_limit}&offset=0&search=&is_paid=false&type=c&status=inFlow`
          ),
          method: "get",
          success: data => {
            this.inFlowCheques = data.results.splice(0,5)
          },
        })
      }
    },
    to(item) {
      return {
        name: "ChequeForm",
        params: {
          id: item.id,
          type: item.type,
          isPaid: item.is_paid,

        },
      };
    },

  },
  computed: {
    list_limit() {
      let list_limit = 50
      if (this.summary) {
        list_limit = 5
      }
      return list_limit
    },
    headers() {
      return [];
    },
  },
}
</script>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer !important;
}
</style>

